import _slicedToArray from '../../../../node_modules/@babel/runtime/helpers/slicedToArray.es.js';
import _objectWithoutProperties from '../../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.es.js';
import _defineProperty from '../../../../node_modules/@babel/runtime/helpers/defineProperty.es.js';
import { zMainNavigation } from '@mgmresorts/wcl-styled';
import { getScrollParent, ConditionalWrapper, Transition } from '@mgmresorts/wcl-utils';
import React, { useState, useRef, useEffect, useCallback } from 'react';
import Portal from '../../../../node_modules/react-portal/es/PortalCompat.es.js';
import { DivWithIntersectionObserver } from '../DivWithIntersectionObserver/DivWithIntersectionObserver.es.js';
import { ZIndexContext } from '../ZIndexContext/ZIndexContext.es.js';
import { StyledFixedNavMainWrapper, ROOM_BOOKING_NAVIGATION_TRANSITION_TIME, StyledFixedNavTransitionUp, StyledNavContainer, StyledNavWrapper, StyledNavContent, StyledLeftElement, StyledCenterElement, StyledRightElement, StyledBottomElement, StyledFixedNavModalOuterWrapper, StyledFixedNavBackgroundWrapper, StyledFixedNavModalInnerWrapper } from './RoomBookingNavigation.styles.es.js';

var _excluded = ["addRightScrollbarOffset", "fullscreenModalTransitionState", "fixedTransition", "className", "isOutsideMainNav", "customNavbar"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var InnerNav = function InnerNav(_ref) {
  var _leftElementRef$curre, _rightElementRef$curr;

  var absolute = _ref.absolute,
      scrolled = _ref.scrolled,
      hidden = _ref.hidden,
      getLeftElement = _ref.getLeftElement,
      getCenterElement = _ref.getCenterElement,
      getRightElement = _ref.getRightElement,
      getBottomElement = _ref.getBottomElement,
      zIndex = _ref.zIndex,
      className = _ref.className,
      isOutsideMainNav = _ref.isOutsideMainNav,
      isUserSignedIn = _ref.isUserSignedIn,
      user = _ref.user,
      links = _ref.links,
      onSignInClick = _ref.onSignInClick;
  var leftElementRef = useRef(null);
  var rightElementRef = useRef(null);
  var renderProps = {
    scrolled: scrolled,
    hidden: hidden
  };
  var leftElement = getLeftElement && getLeftElement(renderProps);
  var centerElement = getCenterElement && getCenterElement(renderProps);
  var rightElement = getRightElement && getRightElement(_objectSpread(_objectSpread({}, renderProps), {}, {
    isUserSignedIn: isUserSignedIn,
    user: user,
    links: links,
    onSignInClick: onSignInClick
  }));
  var bottomElement = getBottomElement && getBottomElement(renderProps);
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    style: _objectSpread(_objectSpread({}, absolute ? {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0
    } : undefined), {}, {
      zIndex: zIndex
    }),
    "data-testid": RoomBookingNavigation.displayName
  }, /*#__PURE__*/React.createElement(StyledNavWrapper, {
    absolute: absolute
  }, /*#__PURE__*/React.createElement(StyledNavContent, {
    absolute: absolute,
    isOutsideMainNav: isOutsideMainNav
  }, !isOutsideMainNav && /*#__PURE__*/React.createElement(StyledLeftElement, {
    ref: leftElementRef
  }, leftElement), isOutsideMainNav && /*#__PURE__*/React.createElement("div", {
    ref: leftElementRef
  }, leftElement), /*#__PURE__*/React.createElement(StyledCenterElement, {
    style: {
      marginRight: isOutsideMainNav && !rightElementRef.current ? "".concat((_leftElementRef$curre = leftElementRef.current) === null || _leftElementRef$curre === void 0 ? void 0 : _leftElementRef$curre.offsetWidth, "px") : '',
      marginLeft: isOutsideMainNav && !leftElementRef.current ? "".concat((_rightElementRef$curr = rightElementRef.current) === null || _rightElementRef$curr === void 0 ? void 0 : _rightElementRef$curr.offsetWidth, "px") : ''
    }
  }, centerElement), (!isOutsideMainNav || isOutsideMainNav && rightElement) && /*#__PURE__*/React.createElement(StyledRightElement, {
    ref: rightElementRef
  }, rightElement))), bottomElement && /*#__PURE__*/React.createElement(StyledBottomElement, {
    absolute: absolute
  }, bottomElement));
};

var observerOptions = {
  rootMargin: '0px',
  threshold: 0.01
};
/**
 * [Documentation](https://mgmdigitalventures.atlassian.net/wiki/spaces/KB/pages/112558474/Room+Booking+Navigation)
 *
 * Renders a <RoomBookingNavigation /> component
 * @param {boolean} addRightScrollbarOffset - an optional param - increase the right offset by the width of the scrollbar
 * @param {TransitionStatus} fullscreenModalTransitionState - an optional param - Replace navbar content from RoomBookingNavigation
 * @param {boolean} fixedTransition - an optional param - Menu stays fixed and animates up
 * @param {string} className - set the class on the element
 * @param {boolean} isOutsideMainNav - an optional param - is navigation rendered outside main views with main nav
 * @param {React.ReactNode} customNavbar - an optional param - Replace navbar content from RoomBookingNavigation
 **/

var RoomBookingNavigation = /*#__PURE__*/React.memo(function (_ref2) {
  var _ref2$addRightScrollb = _ref2.addRightScrollbarOffset,
      addRightScrollbarOffset = _ref2$addRightScrollb === void 0 ? true : _ref2$addRightScrollb,
      _ref2$fullscreenModal = _ref2.fullscreenModalTransitionState,
      fullscreenModalTransitionState = _ref2$fullscreenModal === void 0 ? 'entered' : _ref2$fullscreenModal,
      _ref2$fixedTransition = _ref2.fixedTransition,
      fixedTransition = _ref2$fixedTransition === void 0 ? false : _ref2$fixedTransition,
      className = _ref2.className,
      isOutsideMainNav = _ref2.isOutsideMainNav,
      customNavbar = _ref2.customNavbar,
      props = _objectWithoutProperties(_ref2, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      scrolled = _useState2[0],
      setScrolled = _useState2[1];

  var zIndex = props.zIndex || zMainNavigation;

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      rightScrollbarWidth = _useState4[0],
      setRightScrollbarWidth = _useState4[1];

  var fixedNavChild = /*#__PURE__*/React.createElement(Transition, {
    "in": scrolled,
    timeout: ROOM_BOOKING_NAVIGATION_TRANSITION_TIME
  }, function (transitionState) {
    return /*#__PURE__*/React.createElement(ZIndexContext.Provider, {
      value: zIndex
    }, /*#__PURE__*/React.createElement(StyledFixedNavMainWrapper, {
      zIndex: zIndex,
      right: addRightScrollbarOffset ? rightScrollbarWidth : undefined,
      "aria-hidden": !scrolled
    }, /*#__PURE__*/React.createElement(StyledFixedNavModalOuterWrapper, {
      fixedTransition: fixedTransition,
      fullscreenModalTransitionState: fullscreenModalTransitionState
    }, /*#__PURE__*/React.createElement(StyledFixedNavBackgroundWrapper, {
      fixedTransition: fixedTransition,
      transitionState: transitionState,
      fullscreenModalTransitionState: fullscreenModalTransitionState
    }, /*#__PURE__*/React.createElement(StyledFixedNavModalInnerWrapper, {
      fullscreenModalTransitionState: fullscreenModalTransitionState
    }, customNavbar ? customNavbar(true) : /*#__PURE__*/React.createElement(InnerNav, Object.assign({
      className: className,
      zIndex: zIndex,
      isOutsideMainNav: isOutsideMainNav
    }, {
      scrolled: true,
      hidden: !scrolled,
      getLeftElement: props.leftElement,
      getCenterElement: props.centerElement,
      getRightElement: props.rightElement,
      getBottomElement: props.bottomElement
    })))))));
  });
  var calculateRightScrollbarOffset = props.inTransformContainer && addRightScrollbarOffset;
  var containerRef = useRef(null);
  var scrollParent = useRef();
  useEffect(function () {
    if (calculateRightScrollbarOffset) {
      scrollParent.current = getScrollParent(containerRef.current);
    }
  }, [calculateRightScrollbarOffset]);
  var fixedNav = props.inTransformContainer ? /*#__PURE__*/React.createElement(Portal, {
    node: props.portalNode
  }, fixedNavChild) : fixedNavChild;
  var handleIntersection = useCallback(function (_ref3) {
    var isIntersecting = _ref3.isIntersecting;

    if (calculateRightScrollbarOffset) {
      var nextRightScrollbarWidth = scrollParent.current && scrollParent.current !== window ? scrollParent.current.offsetWidth - scrollParent.current.clientWidth : 0;
      setRightScrollbarWidth(nextRightScrollbarWidth);
    }

    setScrolled(!isIntersecting);
  }, [calculateRightScrollbarOffset]);
  var staticNav = props.renderStaticNav ? props.renderStaticNav() : /*#__PURE__*/React.createElement(ConditionalWrapper, {
    wrapIf: fixedTransition,
    wrapper: StyledFixedNavMainWrapper,
    wrapperProps: {
      zIndex: zIndex,
      right: addRightScrollbarOffset ? rightScrollbarWidth : undefined,
      'aria-hidden': !scrolled
    }
  }, /*#__PURE__*/React.createElement(Transition, {
    "in": !scrolled,
    timeout: ROOM_BOOKING_NAVIGATION_TRANSITION_TIME
  }, function (transitionState) {
    return /*#__PURE__*/React.createElement(StyledFixedNavTransitionUp, {
      transitionState: transitionState
    }, customNavbar ? customNavbar(false) : /*#__PURE__*/React.createElement(InnerNav, Object.assign({
      className: className,
      zIndex: zIndex,
      isOutsideMainNav: isOutsideMainNav
    }, {
      absolute: props.absolute,
      scrolled: false,
      hidden: scrolled,
      getLeftElement: props.leftElement,
      getCenterElement: props.centerElement,
      getRightElement: props.rightElement,
      getBottomElement: props.bottomElement
    })));
  }));
  return /*#__PURE__*/React.createElement("div", {
    ref: containerRef
  }, /*#__PURE__*/React.createElement(DivWithIntersectionObserver, {
    observerOptions: observerOptions,
    onChange: handleIntersection
  }, /*#__PURE__*/React.createElement(StyledNavContainer, null, staticNav)), fixedNav);
});
RoomBookingNavigation.displayName = 'RoomBookingNavigation';

export { RoomBookingNavigation };
